export const MapErrorPlaceholder = (): JSX.Element => <div />;
